module.exports = __webpack_public_path__ + "img/effect_post_measure_vertical.5b625253.png";